import React from "react";
import SectionTitle from "./SectionTitle";
import SectionSubtitle from "./SectionSubtitle";
import SectionContent from "./SectionContent";

const baseSectionStyle = {
  title: "text-2xl font-bold",
  subtitle: "text-lg",
  content: "text-base",
};

const Section = ({ title, badgeText = "", subtitle, content, overrideStyle = {} }) => {
  // TODO: apply override to default object.
  return (
    <div className="flex flex-col w-full gap-2">
      <SectionTitle title={title} badgeText={badgeText} overrideStyle={{}} />
      <SectionSubtitle subtitle={subtitle} />
      <SectionContent>{content}</SectionContent>
    </div>
  );
};

export default Section;
